const THEMOVIEDB_API_KEY = "f045df75beffdcb86a665b711c3787a4";
const GOOGLE_MAPS_KEY = "AIzaSyAGIbJrFSlA1rmrJpwymY3DqPvd9Yc6zUY";

export { THEMOVIEDB_API_KEY, GOOGLE_MAPS_KEY };